module.exports = __webpack_public_path__ + "static/head-bg.c50d6438.png";